import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[invdAvoidSpecialChar]',
})
export class AvoidSpecialCharDirective {
  @HostListener('keypress', ['$event']) onKeyDown(event) {
    if (!this.restrictSpecialChar(event)) {
      event.preventDefault();
    }
  }

  private restrictSpecialChar(e: any): boolean {
    const valid =
      (e.which >= 48 && e.which <= 57) ||
      (e.which >= 65 && e.which <= 90) ||
      (e.which >= 97 && e.which <= 122) ||
      e.which === 8;
    if (valid) {
      return true;
    } else {
      return false;
    }
  }
}
